<template>
  <div v-loading="showFlag">
    <t-card class="card_common">
      <!-- 担当者別の年間売上実績レポート画面 -->
      <div class="annualSalesByUserReportForm">
        <t-form label-position="right" label-width="100px">
          <t-row
            type="flex"
            justify="left
          "
          >
            <t-col :span="16">
              <t-form-item
                :label="$t('resource.CUS_M_ORDER_AMOUNT.PERIOD')"
                class="marginBottom"
              >
                <t-select class="select-year-width" v-model="period.startYear">
                  <t-option
                    v-for="item in yearList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </t-option>
                </t-select>

                <t-select class="select-year-width" v-model="period.startMonth">
                  <t-option
                    v-for="item in monthList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </t-option>
                </t-select>
                <span>&nbsp;&nbsp;～&nbsp;&nbsp;</span>
                <t-select class="select-year-width" v-model="period.endYear">
                  <t-option
                    v-for="item in yearList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </t-option>
                </t-select>

                <t-select class="select-year-width" v-model="period.endMonth">
                  <t-option
                    v-for="item in monthList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </t-option>
                </t-select>
              </t-form-item>
            </t-col>
            <t-col :span="4" class="right">
              <!-- 検索 -->
              <t-button
                round
                type="primary"
                class="button_common_search marginRight"
                @click="searchClick()"
              >
                <i class="el-icon-search"></i>{{ $t("resource.sys.search") }}
              </t-button>
            </t-col>

            <t-col :span="4" class="right">
              <!-- 出力 -->
              <t-button
                round
                type="primary"
                class="button_common"
                ref="outPutBtn"
                @click="outPutClick()"
              >
                <i class="el-icon-download"></i>
                {{ $t("resource.REPORT.REPORT_OUT") }}
              </t-button>
            </t-col>
          </t-row>
          <t-row>
            <t-table
              :data="annualSalesByUserList"
              tooltip-effect="dark"
              style="width: 100%"
              header-cell-class-name="bg-default"
              :max-height="maxheight"
              :span-method="handleSpanMethod"
              @row-dblclick="detailClick"
              highlight-current-row
              border
            >
              <t-table-column
                v-if="periodMonthList.length"
                fixed
                width="100"
                prop="department"
                :label="$t('resource.ANNUAL_SALES_BY_USER.DEPARTMENT')"
              ></t-table-column>
              <t-table-column
                v-if="periodMonthList.length"
                fixed
                width="100"
                prop="contraction"
                :label="$t('resource.ANNUAL_SALES_BY_USER.USER_NAME')"
              ></t-table-column>
              <t-table-column
                v-if="periodMonthList.length"
                fixed
                width="100"
                prop="kbn"
                class-name="cell_txt_center"
                :label="$t('resource.ANNUAL_SALES_BY_USER.KBN')"
              ></t-table-column>

              <t-table-column
                v-for="(column, index) in periodMonthList"
                :key="index"
                :label="column.title"
                min-width="100"
                class-name="cell_txt_right"
                ><template #default="scope">
                  <span>{{ scope.row.dicAmount["amount" + (index + 1)] }}</span>
                </template>
              </t-table-column>

              <t-table-column
                v-if="periodMonthList.length"
                width="150"
                prop="annualTotalAmount"
                class-name="cell_txt_right"
                :label="$t('resource.ANNUAL_SALES_BY_USER.ANNUAL_TOTAL_AMOUNT')"
              ></t-table-column>
              <t-table-column
                v-if="periodMonthList.length"
                width="150"
                prop="monthlyAverageAmount"
                class-name="cell_txt_right"
                :label="
                  $t('resource.ANNUAL_SALES_BY_USER.MONTHLY_AVERAGE_AMOUNT')
                "
              ></t-table-column>
            </t-table>
          </t-row>
        </t-form>
      </div>
    </t-card>
  </div>
</template>
<script>
import { httpApi } from "@/api/api";
import { ShowAnnualSalesDetailByUserReportDialog } from "@/components/Dialog";
import { t } from "@/locales";
import { SearchAnnualSalesByUserData } from "@/services/annualSalesByUserReport";
import { outputExcelToZip } from "@/services/common";
import { Message } from "@tellus/component";

export default {
  data() {
    return {
      //一覧高
      maxheight: window.innerHeight - 140,
      //期間年度
      yearList: [],
      //期間月度
      monthList: [],
      //期間値
      period: {
        startYear: "",
        startMonth: "",
        endYear: "",
        endMonth: "",
      },
      //期間月度
      periodMonthList: [],
      //件数データ
      annualSalesByUserList: [],
      //月度差
      monthsDiff: 0,
      showFlag: false,
    };
  },

  mounted() {
    this.init();

    this.$nextTick(() => {
      this.maxheight = window.innerHeight - 140;
    });
  },

  computed: {},

  methods: {
    // 初期化
    init() {
      this.showFlag = true;
      //システム日
      var systemDate = new Date();
      //システム年
      var systemYear = systemDate.getFullYear();
      //システム月
      var systemMonth = systemDate.getMonth();

      //年度リスト
      for (let year = 2024; year <= systemYear + 1; year++) {
        this.yearList.push({
          value: year,
          label: year + t("resource.CUS_M_ORDER_AMOUNT.YEAR"),
        });
      }

      //月度リスト
      for (let month = 1; month <= 12; month++) {
        this.monthList.push({
          value: month,
          label: month + t("resource.CUS_M_ORDER_AMOUNT.MONTH"),
        });
      }

      //期間の初期値
      //システム月
      if (systemMonth <= 3) {
        //開始年度
        this.period.startYear = systemYear - 1;
        //終了年度
        this.period.endYear = systemYear;
      } else {
        //開始年度
        this.period.startYear = systemYear;
        //終了年度
        this.period.endYear = systemYear + 1;
      }

      //開始月度
      this.period.startMonth = 4;
      //終了月度
      this.period.endMonth = 3;
      //検索
      this.searchClick();
    },

    // 検索
    searchClick() {
      //チェック
      //月度差
      this.monthsDiff =
        (this.period.endYear - this.period.startYear) * 12 -
        parseInt(this.period.startMonth) +
        parseInt(this.period.endMonth);

      // console.log("this.monthsDiff---" + this.monthsDiff);

      if (this.monthsDiff < 0) {
        this.showFlag = false;
        Message.showError(t("message.CUS_M_ORDER_AMOUNT.DATE_COMPARE_MSG"));
        return;
      }

      if (this.monthsDiff >= 12) {
        this.showFlag = false;
        Message.showError(t("message.CUS_M_ORDER_AMOUNT.MONTHS_DIFF_MSG"));
        return;
      }

      SearchAnnualSalesByUserData({
        searchStartYearMonth:
          this.period.startYear + "/" + this.period.startMonth,
        searchEndYearMonth: this.period.endYear + "/" + this.period.endMonth,
      })
        .then((res) => {
          //期間月度
          this.periodMonthList.length = 0;
          let month = this.period.startMonth;
          for (let i = 0; i <= this.monthsDiff; i++) {
            if (parseInt(month) + i <= 12) {
              this.periodMonthList.push({
                title:
                  parseInt(month) + i + t("resource.CUS_M_ORDER_AMOUNT.MONTH"),
              });
            } else {
              this.periodMonthList.push({
                title:
                  parseInt(month) +
                  i -
                  12 +
                  t("resource.CUS_M_ORDER_AMOUNT.MONTH"),
              });
            }
          }

          //データ
          this.annualSalesByUserList = res.annualSalesByUserList;

          this.getBgSpanArr(this.annualSalesByUserList);
          this.showFlag = false;
        })
        .catch((err) => {
          this.showFlag = false;
          Message.showError(
            t("message.CUS_M_ORDER_AMOUNT.SEARCH_FAILURE"),
            null
          );
        });
    },

    // 売上実績出力
    outPutClick() {
      /* this.showFlag = true;

      // 年間売上実績出力
      outputExcelToZip(
        httpApi.OutPutSaleByUseReportInfo,
        this.searchConditionForm
      ).finally(() => {
        this.showFlag = false;
        // フォーカス削除
        this.$refs.outPutBtn.$el.blur();
      }); */

      this.monthsDiff =
        (this.period.endYear - this.period.startYear) * 12 -
        parseInt(this.period.startMonth) +
        parseInt(this.period.endMonth);

      if (this.monthsDiff < 0) {
        this.showFlag = false;
        Message.showError(
          t("message.CUS_M_ORDER_AMOUNT.DATE_COMPARE_MSG"),
          null
        );
        return;
      }

      if (this.monthsDiff >= 12) {
        this.showFlag = false;
        Message.showError(
          t("message.CUS_M_ORDER_AMOUNT.MONTHS_DIFF_MSG"),
          null
        );
        return;
      }

      this.showFlag = true;

      //期間月度
      let monthList = [];
      //開始年月
      let year = this.period.startYear;
      let month = this.period.startMonth;
      //月度値
      let monthValue;
      //年月
      let yearMonth;
      for (let i = 0; i <= this.monthsDiff; i++) {
        if (parseInt(month) + i <= 12) {
          //月度値
          monthValue = parseInt(month) + i;
          //年月
          if (monthValue < 10) {
            yearMonth = year + "_0" + monthValue;
          } else {
            yearMonth = year + "_" + monthValue;
          }
        } else {
          //月度値
          monthValue = parseInt(month) + i - 12;
          //年月
          if (monthValue < 10) {
            yearMonth = year + 1 + "_0" + monthValue;
          } else {
            yearMonth = year + 1 + "_" + monthValue;
          }
        }

        monthList.push(monthValue + t("resource.CUS_M_ORDER_AMOUNT.MONTH"));
      }

      outputExcelToZip(httpApi.OutPutSaleByUseReportInfo, {
        searchStartYearMonth:
          this.period.startYear + "/" + this.period.startMonth,
        searchEndYearMonth: this.period.endYear + "/" + this.period.endMonth,
        annualSalesByUserReportList: monthList,
      })
        .then((res) => {
          //検索
          this.searchClick();
        })
        .finally(() => {
          this.showFlag = false;
        });
    },

    // 一覧表行目結合
    handleSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        return {
          rowspan: row.rowspan,
          colspan: 1,
        };
      }
      if (columnIndex === 1) {
        return {
          rowspan: row.rowspansecond,
          colspan: 1,
        };
      }
    },

    //一覧表行目結合データの取得
    getBgSpanArr(list) {
      let firstIndex = 0;
      let firstItem = "";
      let secondIndex = 0;
      let secondItem = "";

      //
      for (let i = 0; i < list.length; i++) {
        list[i].rowspan = 1;
        list[i].rowspansecond = 1;

        //部門コードの比較
        if (list[i].departmentCode == firstItem) {
          list[firstIndex].rowspan++;
          list[i].rowspan = 0;
        } else {
          firstIndex = i;
          firstItem = list[i].departmentCode;
        }

        //ユーザーIDの比較
        if (list[i].userId == secondItem) {
          list[secondIndex].rowspansecond++;
          list[i].rowspansecond = 0;
        } else {
          secondIndex = i;
          secondItem = list[i].userId;
        }
      }
      this.annualSalesByUserList = list;
    },

    //編集処理
    detailClick(row) {
      if (row.department == t("resource.ANNUAL_SALES_BY_USER.TOTAL")) {
        return;
      }

      //チェック
      //月度差
      this.monthsDiff =
        (this.period.endYear - this.period.startYear) * 12 -
        parseInt(this.period.startMonth) +
        parseInt(this.period.endMonth);

      if (this.monthsDiff < 0) {
        this.showFlag = false;
        Message.showError(t("message.CUS_M_ORDER_AMOUNT.DATE_COMPARE_MSG"));
        return;
      }

      if (this.monthsDiff >= 12) {
        this.showFlag = false;
        Message.showError(t("message.CUS_M_ORDER_AMOUNT.MONTHS_DIFF_MSG"));
        return;
      }

      //個人売上詳細レポート画面
      ShowAnnualSalesDetailByUserReportDialog(
        {
          //担当者コード
          userId: row.userId,
          //担当者名
          userName: row.userName,
          //月度差
          monthsDiff: this.monthsDiff,
          //検索開始年月
          searchStartYearMonth:
            this.period.startYear + "/" + this.period.startMonth,
          //検索終了年月
          searchEndYearMonth: this.period.endYear + "/" + this.period.endMonth,
        },
        t("resource.ANNUAL_SALES_BY_USER.INDIVIDUAL_SALES_DETAIL"),
        this.searchClick
      );
    },
  },
};
</script>
